import { Component, Input, Output, EventEmitter, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import * as feather from 'feather-icons';

export interface WizardStep {
  label: string;
  name: string;
  icon?: string | null;
  fields?: any[];
  completed?: boolean;
}

@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss']
})
export class WizardComponent implements AfterViewInit {
  @Input() steps: WizardStep[] = [];
  @Input() isSubmitting: boolean = false;
  @Input() hideClearAndSave: boolean = false;
  @Input() currentStepIndex: number = 0;
  @Input() hideFooter: boolean = true;
  @Input() allowFreeNavigation: boolean = false;

  @Output() stepChange = new EventEmitter<number>();
  @Output() onClear = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();
  @Output() onBack = new EventEmitter<void>();
  @Output() onNext = new EventEmitter<void>();
  @Output() onSubmit = new EventEmitter<void>();

  constructor(private cdr: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    this.initializeFeatherIcons();
  }

  public goToStep(index: number): void {
    // Verificar se pode navegar para esta etapa
    if (this.canNavigateToStep(index)) {
      this.stepChange.emit(index);
    }
  }

  public canNavigateToStep(index: number): boolean {
    if (this.allowFreeNavigation) {
      return true;
    }
    // Sempre pode navegar para a etapa atual ou anterior
    if (index <= this.currentStepIndex) {
      return true;
    }

    // Para etapas futuras, verificar se todas as etapas anteriores foram concluídas
    for (let i = 0; i < index; i++) {
      if (!this.steps[i]?.completed) {
        return false;
      }
    }

    return true;
  }

  public onBackOrCancel(): void {
    if (this.currentStepIndex === 0) {
      this.onCancel.emit();
    } else {
      this.onBack.emit();
    }
  }

  public onNextOrSubmit(): void {
    if (this.currentStepIndex === this.steps.length - 1) {
      this.onSubmit.emit();
    } else {
      this.onNext.emit();
    }
  }

  private initializeFeatherIcons(): void {
    // Initialize immediately
    feather.replace();

    // Also initialize after a short delay to catch any dynamically added icons
    setTimeout(() => {
      feather.replace();
    }, 100);

    // Additional initialization after view is fully rendered
    setTimeout(() => {
      feather.replace();
    }, 500);
  }
}